import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Button } from 'react-materialize'
import domtoimage from 'dom-to-image';
//import { round } from './Helper'

const google = window.google;
google.charts.load('current', {'packages':['corechart']});


class BarChart extends Component {
    constructor(props) {
      super(props)
      this.state = {
        data: []
      };
    }

  componentDidMount(){
    var chartArray = this.convertData();
    this.renderBarChart(chartArray);
    this.setState({ data: chartArray})
  }

  RenderPicture(){
    var node = document.getElementById('chart_div');
    domtoimage.toJpeg(node, { bgcolor: "white", height: 400, width: 1400 })
     .then(function (dataUrl) {
         var link = document.createElement('a');
         link.download = 'bar_chart.jpeg';
         link.href = dataUrl;
         link.click();
     });
  }

  getLatestYearEachCountry( data, age, gender, yearBound ){
    var latest_year_country = {}
     data.forEach ( data => {
       if( age == data.age && gender == data.gender && data.sample_year <= yearBound[1] && data.sample_year >= yearBound[0]){
         if( latest_year_country.hasOwnProperty(data.country)){
           if(latest_year_country[data.country] < data.sample_year){
             latest_year_country[data.country] = data.sample_year
           }
         } else {
           latest_year_country[data.country] = data.sample_year
         }
       }
     })
    return latest_year_country;
  }

  mapDataWithKeys( data, genders, countries, ages, yearBound){
    var data_map = {};
    var year_chart = {};
    countries.forEach ( country =>
      {
        data_map[country] = {};
          genders.forEach ( gender => {
            ages.forEach( age => {
              data_map[country][`${age}/${gender}`] = {}
              data_map[country][`${age}/${gender}`].value = null;
              data_map[country][`${age}/${gender}`].year = null;
            })
          })
      });


     //data.forEach( document => {
          //one gender one age
    if(genders.length === 1 && ages.length === 1 ){
      year_chart[`${ages[0]}/${genders[0]}`] =  this.getLatestYearEachCountry( data, ages[0], genders[0], yearBound );
      data.forEach (document => {
         countries.forEach(country => {
          if(document.country === country &&
             document.sample_year === year_chart[`${ages[0]}/${genders[0]}`][ country ] &&
             document.gender === genders[0] &&
             document.age === ages[0]){
                 data_map[country][`${ages[0]}/${genders[0]}`].value = document.value;
                 data_map[country][`${ages[0]}/${genders[0]}`].year = document.sample_year;
            }
        })
      })
    } else if (genders.length >= 2 && ages.length === 1){
      year_chart[`${ages[0]}/${genders[0]}`] =  this.getLatestYearEachCountry( data, ages[0], genders[0], yearBound );
      year_chart[`${ages[0]}/${genders[1]}`] =  this.getLatestYearEachCountry( data, ages[0], genders[1], yearBound );
      data.forEach (document => {
         countries.forEach(country => {
          if(document.country === country &&
             document.sample_year === year_chart[`${ages[0]}/${genders[0]}`][ country ] &&
             document.gender === genders[0] &&
             document.age === ages[0]){
                 data_map[country][`${ages[0]}/${genders[0]}`].value = document.value;
                 data_map[country][`${ages[0]}/${genders[0]}`].year = document.sample_year
            } else if (document.country === country &&
                      document.sample_year === year_chart[`${ages[0]}/${genders[1]}`][ country ] &&
                      document.gender === genders[1] &&
                      document.age === ages[0]){
                        data_map[country][`${ages[0]}/${genders[1]}`].value = document.value;
                        data_map[country][`${ages[0]}/${genders[1]}`].year = document.sample_year;

              }
        })
      })
    } else if (genders.length === 1 && ages.length >= 2){
      year_chart[`${ages[0]}/${genders[0]}`] =  this.getLatestYearEachCountry( data, ages[0], genders[0], yearBound );
      year_chart[`${ages[1]}/${genders[0]}`] =  this.getLatestYearEachCountry( data, ages[1], genders[0], yearBound );

      data.forEach (document => {
         countries.forEach(country => {
          if(document.country === country &&
             document.sample_year === year_chart[`${ages[0]}/${genders[0]}`][ country ] &&
             document.gender === genders[0] &&
             document.age === ages[0]){
                 data_map[country][`${ages[0]}/${genders[0]}`].value = document.value;
                 data_map[country][`${ages[0]}/${genders[0]}`].year = document.sample_year;
            } else if (document.country === country &&
                      document.sample_year === year_chart[`${ages[1]}/${genders[0]}`][ country ] &&
                      document.gender === genders[0] &&
                      document.age === ages[1]){
                        data_map[country][`${ages[1]}/${genders[0]}`].value = document.value;
                        data_map[country][`${ages[1]}/${genders[0]}`].year = document.sample_year;
              }
        })
      })
    } else if (genders.length >= 2 && ages.length >= 2){
      year_chart[`${ages[0]}/${genders[0]}`] =  this.getLatestYearEachCountry( data, ages[0], genders[0], yearBound );
      year_chart[`${ages[0]}/${genders[1]}`] =  this.getLatestYearEachCountry( data, ages[0], genders[1], yearBound );
      year_chart[`${ages[1]}/${genders[0]}`] =  this.getLatestYearEachCountry( data, ages[1], genders[0], yearBound );
      year_chart[`${ages[1]}/${genders[1]}`] =  this.getLatestYearEachCountry( data, ages[1], genders[1], yearBound );

      data.forEach (document => {
         countries.forEach(country => {
          if(document.country === country &&
             document.sample_year === year_chart[`${ages[0]}/${genders[0]}`][ country ] &&
             document.gender === genders[0] &&
             document.age === ages[0]){
                 data_map[country][`${ages[0]}/${genders[0]}`].value = document.value;
                 data_map[country][`${ages[0]}/${genders[0]}`].year = document.sample_year;
            } else if (document.country === country &&
                      document.sample_year === year_chart[`${ages[0]}/${genders[1]}`][ country ] &&
                      document.gender === genders[1] &&
                      document.age === ages[0]){
                        data_map[country][`${ages[0]}/${genders[1]}`].value = document.value;
                        data_map[country][`${ages[0]}/${genders[1]}`].year = document.sample_year;
            } else if (document.country === country &&
                      document.sample_year === year_chart[`${ages[1]}/${genders[0]}`][ country ] &&
                      document.gender === genders[0] &&
                      document.age === ages[1]){
                        data_map[country][`${ages[1]}/${genders[0]}`].value = document.value;
                        data_map[country][`${ages[1]}/${genders[0]}`].year = document.sample_year;
            } else if (document.country === country &&
                      document.sample_year === year_chart[`${ages[1]}/${genders[1]}`][ country ] &&
                      document.gender === genders[1] &&
                      document.age === ages[1]){
                        data_map[country][`${ages[1]}/${genders[1]}`].value = document.value;
                        data_map[country][`${ages[1]}/${genders[1]}`].year = document.sample_year;
            }
        })
      })
    }
         //    countries.forEach( country => {
         //      if(document.country === country && document.gender === gender[0] && document.age === age[0]){
         //        data_map[document.sample_year][`${gender[0]}/${age[0]}/${country}`] = document.value;
         //      }
         //    })
         //  } else if (gender.length === 2 && age.length === 1){ //two genders 1 age
         //   countries.forEach( country => {
         //     if(document.country === country && document.gender === gender[0] && document.age === age[0]){
         //       data_map[document.sample_year][`${gender[0]}/${age[0]}/${country}`] = document.value;
         //     } else if (document.country === country && document.gender === gender[1] && document.age === age[0]){
         //       data_map[document.sample_year][`${gender[1]}/${age[0]}/${country}`] = document.value;
         //     }
         //   })
         // } else if (gender.length === 1 && age.length === 2){ //1 gender 2 age
         //   countries.forEach( country => {
         //     if(document.country === country && document.gender === gender[0] && document.age === age[0]){
         //       data_map[document.sample_year][`${gender[0]}/${age[0]}/${country}`] = document.value;
         //     } else if (document.country === country && document.gender === gender[0] && document.age === age[1]){
         //       data_map[document.sample_year][`${gender[0]}/${age[1]}/${country}`] = document.value;
         //     }
         //   })
         // } else if (gender.length === 2 && age.length === 2){
         //   countries.forEach( country => {
         //     if(document.country === country && document.gender === gender[0] && document.age === age[0]){
         //       data_map[document.sample_year][`${gender[0]}/${age[0]}/${country}`] = document.value;
         //     } else if (document.country === country && document.gender === gender[0] && document.age === age[1]){
         //       data_map[document.sample_year][`${gender[0]}/${age[1]}/${country}`] = document.value;
         //     } else if (document.country === country && document.gender === gender[1] && document.age === age[0]){
         //       data_map[document.sample_year][`${gender[1]}/${age[0]}/${country}`] = document.value;
         //     } else if (document.country === country && document.gender === gender[1] && document.age === age[1]){
         //       data_map[document.sample_year][`${gender[1]}/${age[1]}/${country}`] = document.value;
         //     }
         //   })


    //})

    return data_map;
   }

  convertData(){
    const { data, gender, countries, yearBound, sortedAgeByData } = this.props;
    var bar_data = [];
    //var countries_display = [];

    // if(countries.length <= 10){
    //   countries_display = countries;
    // } else {
    //   countries_display = countries.slice(0, 10);
    // }
    if( countries.length <= 10){
      var data_map = this.mapDataWithKeys( data, gender, countries, sortedAgeByData, yearBound);
      if(gender.length === 1 && sortedAgeByData.length === 1){
        var bar_data = [
          ['Country', `Age:${sortedAgeByData[0]}/Gender:${gender[0]}`, {type: 'string', role: 'tooltip'}]
        ];
        Object.keys(data_map).forEach(function(key) {
          let document = data_map[key][`${sortedAgeByData[0]}/${gender[0]}`];
          var value = document.value;
          let year = document.year;
          bar_data.push([key, value, `${value} (Year: ${year})`
                                    ])
        });
      } else if (gender.length === 2 && sortedAgeByData.length === 1 ){
        var bar_data = [
          ['Country', `Age:${sortedAgeByData[0]}/Gender:${gender[0]}`, {'type': 'string', 'role': 'tooltip'}, `Age:${sortedAgeByData[0]}/Gender:${gender[1]}`, {'type': 'string', 'role': 'tooltip'}]
        ];
        Object.keys(data_map).forEach(function(key) {
          let document_1 = data_map[key][`${sortedAgeByData[0]}/${gender[0]}`];
          let document_2 = data_map[key][`${sortedAgeByData[0]}/${gender[1]}`];
          let value_1 = document_1.value;
          let value_2 = document_2.value;
          bar_data.push([key, value_1,
                              `${value_1} (Year: ${document_1.year})`,
                              value_2,
                              `${value_2} (Year: ${document_2.year})`,])
        });
      } else if (gender.length === 1 && sortedAgeByData.length === 2){
        console.log("im here");
        var bar_data = [
          ['Country', `Age:${sortedAgeByData[0]}/Gender:${gender[0]}`, {'type': 'string', 'role': 'tooltip'}, `Age:${sortedAgeByData[1]}/Gender:${gender[0]}`, {'type': 'string', 'role': 'tooltip'}]
        ];
        Object.keys(data_map).forEach(function(key) {
          let document_1 = data_map[key][`${sortedAgeByData[0]}/${gender[0]}`];
          let document_2 = data_map[key][`${sortedAgeByData[1]}/${gender[0]}`];
          let value_1 = document_1.value;
          let value_2 = document_2.value;
          bar_data.push([key, value_1,
                              `${value_1} (Year: ${document_1.year})`,
                              value_2,
                              `${value_2} (Year: ${document_2.year})`])
        });
      } else if (gender.length === 2 && sortedAgeByData.length === 2){
        var bar_data = [
          ['Country', `Age:${sortedAgeByData[0]}/Gender:${gender[0]}`,
                      {'type': 'string', 'role': 'tooltip'},
                      `Age:${sortedAgeByData[0]}/Gender:${gender[1]}`,
                      {'type': 'string', 'role': 'tooltip'},
                      `Age:${sortedAgeByData[1]}/Gender:${gender[0]}`,
                      {'type': 'string', 'role': 'tooltip'},
                      `Age:${sortedAgeByData[1]}/Gender:${gender[1]}`,
                      {'type': 'string', 'role': 'tooltip'}
            ]];
        Object.keys(data_map).forEach(function(key) {
          let document_1 = data_map[key][`${sortedAgeByData[0]}/${gender[0]}`];
          let document_2 = data_map[key][`${sortedAgeByData[0]}/${gender[1]}`];
          let document_3 = data_map[key][`${sortedAgeByData[1]}/${gender[0]}`];
          let document_4 = data_map[key][`${sortedAgeByData[1]}/${gender[1]}`];
          let value_1 = document_1.value;
          let value_2 = document_2.value;
          let value_3 = document_3.value;
          let value_4 = document_4.value;
          bar_data.push([key, value_1,
                              `${value_1} (Year: ${document_1.year})`,
                              value_2,
                              `${value_2} (Year: ${document_2.year})`,
                              value_3,
                              `${value_3} (Year: ${document_3.year})`,
                              value_4,
                              `${value_4} (Year: ${document_4.year})`])
        });
      }


      if( bar_data.length >= 2){
        var null_index = [];
        bar_data[1].forEach((data, index) => {
          if(data === null){
            null_index.push(index)
          }
        });

        for(let i = 2; i < bar_data.length; i++){
          for(let j = null_index.length - 1; j >= 0; j--){
            if(bar_data[i][null_index[j]] !== null){
              null_index.splice(j, 1);
            }
          }
        }
        if(null_index.length !== 0){
          for(let i = null_index.length-1; i >= 0; i --){
            for(let j = 0; j < bar_data.length; j ++){
              bar_data[j].splice(null_index[i] + 1, 1)
              bar_data[j].splice(null_index[i], 1)
            }
          }
        }
      }
    }
    return bar_data;
  }

  renderBarChart(arr){
      google.charts.load('current', {
        callback: function () {
          var data = google.visualization.arrayToDataTable(arr);
          var container = document.getElementById('chart_div');
          var chart = new google.visualization.ColumnChart(container);
          var colors = ['#003864', '#67d1d3', '#c4d600', '#d0006f']

          // google.visualization.events.addListener(chart, 'ready', changeBorderRadius);
          // google.visualization.events.addListener(chart, 'select', changeBorderRadius);
          // google.visualization.events.addListener(chart, 'onmouseover', changeBorderRadius);
          // google.visualization.events.addListener(chart, 'onmouseout', changeBorderRadius);
          var options = {
            vAxis: { baseline: 0 },
            colors: colors,
            legend: 'bottom',
            chartArea: {width: '90%', height: "90%"},
            focusTarget: 'category',
            tooltip: { isHtml: true }
          };


          // function changeBorderRadius() {
          //   var chartColumns = container.getElementsByTagName('rect');
          //   Array.prototype.forEach.call(chartColumns, function(column) {
          //     if ( column.getAttribute('width') > 20 && (
          //         (colors.indexOf(column.getAttribute('fill')) > -1) ||
          //         (column.getAttribute('fill') === 'none') ||
          //         (column.getAttribute('stroke') === '#ffffff'))) {
          //       column.setAttribute('rx', 20);
          //       column.setAttribute('ry', 20);
          //     }
          //   });
          // }

          chart.draw(data, options);
        },
        packages: ['corechart']
      });
  }
  render() {
  const { countries, yearBound, age, gender } = this.props;
  const { data } = this.state;
  return (
    <div id="bar_chart">
      {/* {
        countries.length > 6?
          (<div>A maximum of six countries can be shown on this chart type.</div>): countries.length === 0?
          (<div>Please select at least one country</div>):data.length === 1?
            (<div>No data available.</div>):
              (
                <div>
                  <div>
                    Data reflects most recent year available.
                  </div>
                  <div id="chart_div" style={{height: "800px"}}>
                  </div>
                  <div className="pulled-right">
                    <Button onClick={()=>{this.RenderPicture()}}>DOWNLOAD .JPG</Button>
                  </div>
              </div>
        )
      } */}
      {
        data.length === 0 || data[0].length === 1 || data.length === 1?"":
        <div>
          {/* {countries.length > 6 || age.length > 2 || gender.length > 2?<div>Display limits: latest data year per country, 2 age categories, 6 countries</div>: ""} */}
          {/* {age.length > 2?<div>A maxium of two age groups can be selected.</div>: ""}
          {gender.length > 2?<div>A maxium of two gender groups can be selected.</div>: ""} */}
          <div>
            <div id="chart_div" style={{height: "800px"}}>
            </div>
            <div className="pulled-right">
              <Button onClick={()=>{this.RenderPicture()}}>DOWNLOAD JPG</Button>
            </div>
        </div>
        </div>
      }
    </div>
  )}
}

function mapStateToProps(state){
  return {
    data: state.data,
    gender: state.gender,
    yearBound: state.yearBound,
    countries: state.countries,
    age: state.age,
    sortedAgeByData: state.sortedAgeByData
    }
};


export default connect(mapStateToProps)(BarChart);



// WEBPACK FOOTER //
// ./src/components/BarChart_2.js